export default __webpack_public_path__ + "9329e514180f62ffe278481d19222bf5.svg";